function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStateAdd = function SvgStateAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M512 64.7C265 64.7 64.7 265 64.7 512S265 959.3 512 959.3 959.3 759 959.3 512 759 64.7 512 64.7m216.9 489.8H554.5v174.4c0 23.5-19 42.5-42.5 42.5s-42.5-19-42.5-42.5V554.5H295.1c-23.5 0-42.5-19-42.5-42.5s19-42.5 42.5-42.5h174.4V295.1c0-23.5 19-42.5 42.5-42.5s42.5 19 42.5 42.5v174.4h174.4c23.5 0 42.5 19 42.5 42.5s-19 42.5-42.5 42.5",
    style: {
      fill: "#319eff"
    }
  }));
};
export default SvgStateAdd;